<template>
  <div class="container-fluid">
    <nav style="padding: 0px">
      <!-- <site-nav-bar-login v-if="isLoggedIn" :userName="username">
      </site-nav-bar-login> -->

      <site-nav-bar-Landing v-if="isLoggedIn" :userName="username">
      </site-nav-bar-Landing>
    </nav>
    <router-view style="padding-top: 150px;"/>
  </div>
</template>
<script>
import SiteNavBarLogin from "@/components/SiteNavBarLogin.vue";
import SiteNavBarLanding from "@/components/SiteNavBarLanding.vue";
export default {
  components: { SiteNavBarLogin, SiteNavBarLanding },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.userName;
    },
  },
};
</script>

<style>
#app {
  font-family: OpenSans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* background-color: whitesmoke; */
  /* background-image: linear-gradient(
    -225deg,
    #69eacb 0%,
    #eaccf8 48%,
    #6654f1 100%
  ); */
  /* background-image: linear-gradient(90deg,
      rgba(127, 229, 154, 0.8128501400560224) 0%,
      rgba(29, 253, 149, 0.4767156862745098) 50%,
      rgba(252, 69, 230, 0.32825630252100846) 100%);*/
  display: flex;
  flex-direction: column;
  height: 100vh;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
